<Dialog :header="title" v-model:visible="visibleModel">
    <form class="vl-form" @submit="onSubmit">
        <div class="aeg-form-layout">
            <div class="aeg-label-above-layout">
                <aeg-field-validation-wrapper :error-message="errors.email" name="E-mail" mod-required #default="{hasErrors}">
                    <InputText name="email" v-model="email" v-bind="emailProps" :invalid="hasErrors"/>
                </aeg-field-validation-wrapper>
            </div>
            <div class="aeg-label-above-layout" v-if="actor.emails.length > 1">
                <aeg-field-validation-wrapper :error-message="errors.email" name="E-mail CC" mod-required #default="{hasErrors}">
                    <InputText name="emailCc" v-model="emailCc" v-bind="emailCcProps" :invalid="hasErrors"/>
                </aeg-field-validation-wrapper>
            </div>
        </div>
    </form>
    <template v-slot:footer>
        <Button :disabled="disableSubmit || savingEmails" type="submit">
            Wijzigingen opslaan
        </Button>
        <aeg-cancel-button @click="onCloseModal" />
    </template>
</Dialog>
